export default function PseudoCityChanger(){

    $("#city-changer_pseudo_open").on('click',function(){
        if(!$('#city-changer_pseudo_menu_wrapper').hasClass('opened')){
            $('#city-changer_pseudo_menu_wrapper').addClass('opened');
            
                $(window).mouseup( function(e){ // событие клика по веб-документу
                    var div = $( "#city-changer_pseudo_menu" ); // тут указываем ID элемента
                    if ( !div.is(e.target) // если клик был не по нашему блоку
                        && div.has(e.target).length === 0 ) { // и не по его дочерним элементам
                            ClosePseudoModal(); // скрываем его
                    }
                });
            
        }
    });
    $('#city-changer__close').on('click',function(){
        ClosePseudoModal();
    });
    
}

function ClosePseudoModal(){
    $('#city-changer_pseudo_menu_wrapper').removeClass('opened');
}